import React from "react";
import { connect } from "react-redux";
import "../Forms/css/register.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";

const token = localStorage.getItem('authToken');

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: "",
      name: "",
      city: '',
      area: '',
      phoneNo: '',
      password: '',
      errors: {},
      submeet: false,
      showPassword: false,
      submissionStatus: null,
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      submitted: false,
    });
  };

  handleFileChange = (e) => {
    const { name, files } = e.target;
    this.setState({
      [name]: files[0],
      submitted: false,
    });
  };

  validateForm = () => {
    const { city, phoneNo, password, textInput, name } = this.state;
    const errors = {};
    let isValid = true;

    if (!city) {
      errors.city = 'City is required';
      isValid = false;
    }
    if (!textInput) {
      errors.textInput = 'First Name is required';
      isValid = false;
    }
    if (!name) {
      errors.name = 'Last Name is required';
      isValid = false;
    }
    if (!phoneNo.match(/^\d{10}$/)) {
      errors.phoneNo = 'Mobile number must be exactly 10 digits';
      isValid = false;
    }
    if (password.length < 6) {
      errors.password = 'Password must be at least 6 characters long';
      isValid = false;
    }

    this.setState({ errors });
    return isValid;
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    this.setState({ submitted: true });

    console.log("1")
    try {
      const formData = new FormData();
      const { city, phoneNo, password, textInput, name } = this.state;

      formData.append('city', city);
      formData.append('phoneNumber', phoneNo);
      formData.append('password', password);
      formData.append('firstName', textInput);
      formData.append('lastName', name);

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post("https://brand.aasmo.in/api/users/signup", formData, config);

      if (response && response.status === 201) {
        this.setState({ submissionStatus: 'success' });
        setTimeout(() => {
          window.location.href = "/list";
        }, 2000);
      } else {
        console.log('Unexpected response:', response);
      }

    } catch (error) {
      console.error('Error submitting form:', error);
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          console.error('Bad request error:', data);
        } else if (status === 401) {
          console.error('Unauthorized error, please log in again.');
        } else {
          console.error('Error response:', error.response);
        }
      } else {
        console.error('Network or other error:', error);
      }
    }
  };

  render() {
    const { city, password, submissionStatus, showPassword, errors, submitted, textInput, phoneNo, name } = this.state;

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Add</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label>First Name</label>
                <input
                  className={`form-control ${textInput === "" && submitted ? "parsley-error" : ""}`}
                  value={textInput}
                  name="textInput"
                  required
                  onChange={this.handleChange}
                />
                {textInput === "" && submitted ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input
                  className={`form-control ${name === "" && submitted ? "parsley-error" : ""}`}
                  value={name}
                  name="name"
                  required
                  onChange={this.handleChange}
                />
                {name === "" && submitted ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Phone No</label>
                <input
                  type="text"
                  className={`form-control ${phoneNo.length !== 10 && submitted ? "parsley-error" : ""}`}
                  value={phoneNo}
                  name="phoneNo"
                  maxLength="10"
                  required
                  onChange={this.handleChange}
                />
                {phoneNo.length !== 10 && submitted ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">phoneNo must be exactly 10 digits.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>City</label>
                <input
                  type="text"
                  className={`form-control ${errors.city ? "parsley-error" : ""}`}
                  name="city"
                  value={city}
                  onChange={this.handleChange}
                />
                {errors.city && submitted && <div className="parsley-errors-list">{errors.city}</div>}
              </div>
              <div className="form-group">
                <label>Password</label>
                <div className="password-input-container">
                  <input
                    className={`form-control ${!password && submitted ? 'parsley-error' : ''}`}
                    value={password}
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    onChange={this.handleChange}
                  />
                  <span className="password-toggle-icon" onClick={this.togglePasswordVisibility}>
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </span>
                </div>
                {!password && submitted ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">Password is required.</li>
                  </ul>
                ) : null}
              </div>
              {submissionStatus === 'success' && (
                <div className="alert alert-success">Form submitted successfully!</div>
              )}
              <button type="submit" className="btn btn-primary">Submit</button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Register);
